import { mdiCog } from '@mdi/js'

export default [
  {
    title: 'تنظیمات',
    icon: mdiCog,
    action: 'can_see_setting',
    resource: 'all',
    children: [
      {
        title: 'امنیت ',
        to: 'security-setting',
        action: 'can_edit_bill_safety',
        resource: 'all',
      },
      {
        title: 'تنظیمات فروش',
        to: 'shop-setting',
        action: 'can_edit_shop_setting',
        resource: 'all',
      },
      {
        title: 'مپ حساب های ربات',
        to: 'bot-mapping',
        action: 'can_see_bot_mapping',
        resource: 'all',
      },
      {
        title: 'اعلانات ربات',
        to: 'bot-notifs',
        action: 'can_see_bot_notification',
        resource: 'all',
      },
      {
        title: 'تنظیمات سئو',
        to: 'seo-setting',
        resource: 'all',
      },
      {
        title: 'تنظیمات دسترسی به گیفت کارت ها',
        to: 'access-gift-carts',
        action: 'can_edit_gift_access',
        resource: 'all',
      },
      {
        title: 'درگاه های پرداخت',
        to: 'gate',
        action: 'can_edit_gate',
        resource: 'all',
      },
      {
        title: 'کیف پول وب سایت',
        to: 'wallet-setting',
        action: 'can_see_wallet_management',
        resource: 'all',
      },
      {
        title: 'تغییر متن قوانین و ارتباط با ما',
        to: 'policy-setting',
        action: 'can_edit_policy_setting',
        resource: 'all',
      },
      {
        title: 'الگو های رد احراز',
        to: 'auth-user-template-setting',
        action: 'can_see_and_edit_auth_user_template',
        resource: 'all',
      },
      {
        title: 'نمونه تصاویر احراز',
        to: 'auth-user-sample-setting',
        action: 'can_manage_site_builder',
        resource: 'all',
      },
      {
        title: 'بنرهای صفحه اصلی',
        to: 'collections-web',
        action: 'can_manage_site_builder',
        resource: 'all',
      },
    ],
  },
]
